import Vue from 'vue';
import VueRouter, { RawLocation, RouteConfig } from 'vue-router';

import applicationConstant from '@/constants/application.constant';
import { AUTH_ROLES } from '@/constants/roles.constant';
import { campaignsRouter } from '@/modules/campaigns/campaigns.module';
import { challengesRouter } from '@/modules/challenges/challenges.module';
import { chatRouter } from '@/modules/chat/chat.module';
import { communicationsRouter } from '@/modules/communications/communications.module';
import { counterpartsRouter } from '@/modules/counterparts/counterparts.module';
import { dashboardRouter } from '@/modules/dashboard/dashboard.module';
import { detailsRouter } from '@/modules/details/details.module';
import { externalRouter } from '@/modules/external/external.module';
import { linksRouter } from '@/modules/links/links.module';
import { AppScene, mainRouter } from '@/modules/main/main.module';
import { membersRouter } from '@/modules/members/members.module';
import { mentionsRouter } from '@/modules/mentions/mentions.module';
import { ordersRouter } from '@/modules/orders/orders.module';
import { productsOfferedRouter } from '@/modules/products-offered/products-offered.module';
import { productsRouter } from '@/modules/products/products.module';
import { remunerationsRouter } from '@/modules/remunerations/remunerations.module';
import { socialNetwork } from '@/modules/social-network/social-network.module';

const { BASE_URL = '/' } = process.env || {};

Vue.use(VueRouter);

const root = {
  beforeEnter: () => {
    window.location.href = `${applicationConstant.defaultPage}${window.location.search}`;
  },
  path: ''
};

const routes: Array<RouteConfig> = [
  {
    path: '',
    redirect: 'app'
  },
  {
    children: [
      root,
      ...dashboardRouter,
      ...challengesRouter,
      ...counterpartsRouter,
      ...mentionsRouter,
      ...detailsRouter,
      ...externalRouter,
      ...ordersRouter,
      ...productsRouter,
      ...productsOfferedRouter,
      ...remunerationsRouter,
      ...campaignsRouter,
      ...membersRouter,
      ...communicationsRouter,
      ...chatRouter,
      ...linksRouter,
      ...socialNetwork
    ],
    component: AppScene,
    meta: {
      requiresAuth: true,
      roles: [AUTH_ROLES.PARTNERSHIP_USER]
    },
    path: '/app'
  },
  ...mainRouter
];

const router = new VueRouter({
  base: BASE_URL,
  mode: 'history',
  routes
});

const originalMethod = VueRouter.prototype['push'];
router.push = function push(
  location: RawLocation,
  onComplete?: Function,
  onAbort?: (err: Error) => void
) {
  if (onComplete || onAbort) {
    return originalMethod.call(this, location, onComplete, onAbort);
  }

  return originalMethod.call(this, location).catch((err) => {
    if (err.name !== 'NavigationDuplicated') {
      return Promise.reject(err);
    }

    return err;
  });
};

export default router;
